import dayjs from "dayjs";
import {
    BalanceDetails,
    BankDetailsResponse,
    CompanyResponse,
    PendingTransactionsResponse,
} from "./types";

export const HourlyEmployee = "Hourly";

export const useWithdrawalValidation = (
    company?: CompanyResponse | null,
    balanceDetails?: BalanceDetails,
    bankDetails?: BankDetailsResponse | null,
    pendingTransactions?: number,
    isPayrollProcessed?: boolean
) => {
    const isFullTimeEmployee = balanceDetails?.employmentType != HourlyEmployee;

    const dayExceededLastWithdrawal = company?.latestWithdrawalDay
        ? isFullTimeEmployee && company?.latestWithdrawalDay < dayjs().date()
        : false;

    const currentMonthPayrollExists =
        (isFullTimeEmployee && (isPayrollProcessed ?? false)) ||
        dayExceededLastWithdrawal;

    // US-3052 / Feature 3046. Withdraw-gate is BE-authoritative.
    // `hasBankDetails` is computed server-side via
    // `PayoutDestinationProjection.HasUsableRoute` (true ⇔ PayoutRouter
    // can resolve any receiver: BBAN, IBAN, or NemKonto+CPR). Backoffice
    // consumers that don't receive this from BE must compute and supply
    // it at the call site (see UserDetailsPage).
    const bankDetailsEmpty = !bankDetails?.hasBankDetails;

    // US-3191: specific blocking reason — IBAN destination country not on the SEPA
    // supported list. Distinct from generic bankDetailsEmpty so the FE can show a
    // targeted message. When true, bankDetailsEmpty is also true.
    const isUnsupportedDestinationCountry = !!bankDetails?.isUnsupportedDestinationCountry;

    const alreadyProcessingTransactions = pendingTransactions! > 0 || false;
    const isNemkonto = bankDetails?.isNemkonto;
    const isNemkontoMissingCpr =
        !!bankDetails?.isNemkonto && !bankDetails?.cprNumber;

    return {
        isFullTimeEmployee,
        dayExceededLastWithdrawal,
        bankDetailsEmpty,
        currentMonthPayrollExists,
        alreadyProcessingTransactions,
        isNemkonto,
        isNemkontoMissingCpr,
        isUnsupportedDestinationCountry,
    } as const;
};
